// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from 'react'
import './App.css'
import * as microsoftTeams from '@microsoft/teams-js'
import { BrowserRouter as Router, Route } from 'react-router-dom'

import Privacy from './Privacy'
import TermsOfUse from './TermsOfUse'
import TabConfig from './TabConfig'
import { MyPowtoonsTab } from './MyPowtoons'
import { HelpTab } from './HelpTab'
import { CreateTab } from './CreateTab'
import { TestTab } from './mock-components/TestTab'
import { InsideIframe } from './mock-components/InsideIframe'
import OAuthCallback from './OAuthCallback'
import { oauthUrl } from '../utils/auth'
import Tab from './Tab'
import { TestTaskModule } from './mock-components/TestTaskModule'
import { ChoosePowtoonMessageExtensionMock } from './mock-components/ChoosePowtoonMessageExtensionMock'
const qs = require('qs')

/**
 * The main app which handles the initialization and routing
 * of the app.
 */
function App() {

  useEffect(() => {
    // Initialize Microsoft Teams SDK on mount
    async function initTeamsSdk() {
      try {
        await microsoftTeams.app.initialize()
      } catch (err) {
        console.error("Error initializing Teams SDK", err)
      }
    }

    initTeamsSdk()
  }, [])

  const devOnlyRoutes = [
    <Route exact path="/choose-powtoon-mock" component={ChoosePowtoonMessageExtensionMock} />,
    <Route exact path="/view-powtoon-mock" component={ChoosePowtoonMessageExtensionMock} />
  ]
  // Display the app home page hosted in Teams
  return (
    <Router>
      <Route exact path="/privacy" component={Privacy} />
      <Route exact path="/termsofuse" component={TermsOfUse} />
      <Route exact path="/my-powtoons" component={MyPowtoonsTab} />
      <Route exact path="/help-support" component={HelpTab} />
      <Route exact path="/create-new" component={CreateTab} />
      <Route exact path="/test" component={TestTab} />
      <Route exact path="/inside-iframe" component={InsideIframe} />
      <Route exact path="/config" component={TabConfig} />
      <Route exact path="/tab" component={Tab} />
      <Route exact path="/task-module" component={TestTaskModule} />
      <Route exact path="/oauth/authorize" component={(props) => {
        const { state } = qs.parse(props.location.search, { ignoreQueryPrefix: true })
        window.location.assign(oauthUrl(state))
        return null
      }} />
      <Route exact path="/oauth/callback" component={OAuthCallback} />
      {devOnlyRoutes}
    </Router>
  )
}

export default App
